import moment from 'moment';

const CLOCK_FORMATS = ['HH:mm:ss', 'HH:mm', 'H:mm:ss', 'H:mm'];

/**
 * Parse a nozzle shift clock value.
 * Accepts a moment, a time string, or null. Never returns an invalid moment
 * (those format as the literal "Invalid date").
 */
export const parseNozzleClock = (value) => {
	if (value == null || value === '') {
		return null;
	}

	if (moment.isMoment(value)) {
		return value.isValid() ? value.clone() : null;
	}

	if (typeof value === 'string' && /^invalid date$/i.test(value.trim())) {
		return null;
	}

	const parsed = moment(value, CLOCK_FORMATS, true);
	return parsed.isValid() ? parsed : null;
};

/**
 * Format a nozzle clock for display or API.
 * Returns '' when the value cannot be parsed.
 */
export const formatNozzleClock = (value, pattern = 'HH:mm:ss') => {
	const parsed = parseNozzleClock(value);
	return parsed ? parsed.format(pattern) : '';
};

/**
 * End time single-nozzle close should submit.
 * Saved end time wins; otherwise the same-shift suggested end time
 * (the value Close all nozzles already uses).
 */
export const resolveNozzleEndClock = (endFrom, suggestedEndFrom) => {
	return parseNozzleClock(endFrom) || parseNozzleClock(suggestedEndFrom);
};

/**
 * Start time to compare and store. Shown start wins; otherwise the shift start.
 */
export const resolveNozzleStartClock = (showStartFrom, startFrom) => {
	return parseNozzleClock(showStartFrom) || parseNozzleClock(startFrom);
};

/**
 * Same-day rule used by Close all nozzles: end clock must be >= start clock.
 * Returns an error string, or '' when the pair is acceptable.
 * A missing end time is an error. A missing start time is not compared.
 */
export const sameDayNozzleCloseTimeError = (startClock, endClock) => {
	if (!endClock) {
		return 'Enter End Time';
	}
	if (!startClock) {
		return '';
	}
	if (endClock.format('HH:mm:ss') < startClock.format('HH:mm:ss')) {
		return 'On same date,end time should be greater than start time.';
	}
	return '';
};
